import React, { Component } from "react";
import authUser from '../../assets/js/auth'
import "./css/InvestForm.css";
import StripeCheckout from "react-stripe-checkout";
import CharryConverter from "../../assets/js/conversionCharry";
import FormBuilder from "../../assets/js/formBuilder";
import Utils from "../../utils/index";
import SendingTokensModal from "../SendingTokensModal";
import { Button, Modal } from "react-bootstrap";
import axios from "axios";

require("dotenv").config();

const ICO_CONTRACT_ADDRESS = process.env.REACT_APP_ICO_CONTRACT_ADDRESS;
const STRIPE_PUBLIC = process.env.REACT_APP_STRIPE_PUBLIC;

export class InvestForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isbuyingTokens: false,
            showDialog: false,
            tronWeb: {
                installed: false,
                loggedIn: false,
            },
            transactions: {},
            sendingTokens: false,
            loggedIn: false,
        };
        this.handleClose = this.handleClose.bind(this);
        this.makePayment = this.makePayment.bind(this);
    }

    async componentWillMount() {
        this.setState({ loading: true });
        authUser.isAuthenticated()
        if (authUser.authenticated === "false") {
            this.setState({ loggedIn: false })
        } else {
            this.setState({ loggedIn: true })
        }
        axios.defaults.withCredentials = false;
        await new Promise((resolve) => {
            const tronWebState = {
                installed: !!window.tronWeb,
                loggedIn: window.tronWeb && window.tronWeb.ready,
            };

            if (tronWebState.installed) {
                this.setState({
                    tronWeb: tronWebState,
                });

                return resolve();
            }

            let tries = 0;

            const timer = setInterval(() => {
                if (tries >= 10) {
                    this.setState({
                        tronWeb: {
                            installed: false,
                            loggedIn: false,
                        },
                    });

                    clearInterval(timer);
                    return resolve();
                }

                tronWebState.installed = !!window.tronWeb;
                tronWebState.loggedIn = window.tronWeb && window.tronWeb.ready;

                if (!tronWebState.installed) return tries++;

                this.setState({
                    tronWeb: tronWebState,
                });

                resolve();
            }, 100);
        });
        await this.loadICOTransactions();
    }

    async loadICOTransactions() {
        axios.defaults.withCredentials = false;
        axios
            .get(
                `${process.env.REACT_APP_TRON_API}/v1/contracts/${ICO_CONTRACT_ADDRESS}/transactions`
            )
            .then((res) => {
                console.log(res.data.data);
                this.setState(
                    {
                        transactions: res.data.data,
                    });
            });
    }

    handleClose() {
        this.setState({
            showDialog: false,
        });
    }

    handleShow() {
        this.setState({ showDialog: true });
    }


    async buytokensLoggedIn(e) {
        e.preventDefault();
        axios.defaults.withCredentials = false;
        let tronWebState = this.state.tronWeb;
        if ((!tronWebState.installed || !tronWebState.loggedIn) && this.props.active === "TRX") {
            this.setState({
                showDialog: true,
            });
        } else if (
            this.props.active === "TRX" &&
            tronWebState.installed &&
            tronWebState.loggedIn
        ) {
            this.setState({ sendingTokens: true })
            let numTokens = CharryConverter.fromCharry(this.props.input);
            let userWalletAddress = window.localStorage.getItem('account');

            await Utils.setTronWeb(window.tronWeb, ICO_CONTRACT_ADDRESS);

            await Utils.contract
                .invest(userWalletAddress, numTokens)
                .send({
                    shouldPollResponse: true,
                    callValue: Utils.tronWeb.toSun(this.props.input),
                })
                .then((hash) => {
                    console.log(hash);
                    this.setState({ sendingTokens: false })
                })
                .catch((err) => {
                    console.log(err);
                    this.setState({ sendingTokens: false })
                });

        } else if (this.props.active === "FIAT") {
            await axios.post(`${process.env.REACT_APP_BACKEND_API}/paymentINR`, {
                phone: `${window.localStorage.getItem('MobileNumber')}`,
                amount: `${this.props.inputRef.current.value}`
            }).then(async (res) => {
                console.log(res.data)
                let information = {
                    action: "https://securegw-stage.paytm.in/order/process",
                    params: res.data
                }
                FormBuilder.post(information)
            }).catch((error) => {
                console.log("Error")
            })
        }
    }


    async buytokens(e) {
        e.preventDefault();
        axios.defaults.withCredentials = false;
        let tronWebState = this.state.tronWeb;
        if ((!tronWebState.installed || !tronWebState.loggedIn) && this.props.active === "TRX") {
            this.setState({
                showDialog: true,
            });
        } else if (
            this.props.active === "TRX" &&
            tronWebState.installed &&
            tronWebState.loggedIn
        ) {
            this.setState({ sendingTokens: true })
            let numTokens = CharryConverter.fromCharry(this.props.input);
            let userWalletAddress = window.tronWeb.defaultAddress.base58;

            await Utils.setTronWeb(window.tronWeb, ICO_CONTRACT_ADDRESS);

            await Utils.contract
                .invest(userWalletAddress, numTokens)
                .send({
                    shouldPollResponse: true,
                    callValue: Utils.tronWeb.toSun(this.props.input),
                })
                .then((hash) => {
                    console.log(hash);
                    this.setState({ sendingTokens: false })
                })
                .catch((err) => {
                    console.log(err);
                    this.setState({ sendingTokens: false })
                });

        } else {
            this.props.onOpenModalLogin()
        }
    }

    async makePayment(token) {
        axios.defaults.withCredentials = true;
        await axios.post(`${process.env.REACT_APP_BACKEND_API}/paymentUSD`, {
            usdAmt: this.props.inputRef.current.value,
            token: token
        }).then((res) => {
            console.log(res.data.code)
            console.log(res.data.status)
            window.location.href = `/${res.data.status}/${res.data.code}`
        }).catch((error) => {
            console.log("Error")
        })
    }

    render() {
        let investButton;
        if ((window.localStorage.getItem('CurrentCurrency') === 'usd' && this.props.active !== "TRX") && window.localStorage.getItem('MobileLogin') === "true") {
            if (this.props.input === "0") {
                investButton = <button type="submit" className="me-btn">Invest</button>
            } else {
                investButton = <StripeCheckout stripeKey={STRIPE_PUBLIC} token={this.makePayment} name="Buy CHY" billingAddress shippingAddress><button type="button" className="me-btn">Invest</button></StripeCheckout>
            }
        } else {
            investButton = <button type="submit" className="me-btn">Invest</button>
        }
        return (
            <>
                <form
                    onSubmit={(event) => {
                        if (this.state.loggedIn === true) {
                            event.preventDefault()
                            this.buytokensLoggedIn(event);
                        } else {
                            event.preventDefault()
                            this.buytokens(event);
                        }

                    }}
                >
                    {/* <div className="form-group row connected-wallet">
                        <label htmlFor="staticEmail" className="col-sm-12 col-form-label"><b>Connected To: &nbsp; </b><span> 123</span></label>
                    </div> */}
                    <div>
                        <label className="float-left invest-label">
                            <b>Investment Amount ({this.props.active === 'FIAT' ? (window.localStorage.getItem('CurrentCurrency') ? window.localStorage.getItem('CurrentCurrency').toUpperCase() : 'INR') : 'TRX'})</b>
                        </label>
                    </div>
                    <div className="input-group mb-4">
                        <input
                            type="text"
                            name="input"
                            onChange={(e) => {
                                this.props.handleInput(e);
                            }}
                            className="form-control"
                            placeholder="0"
                            ref={this.props.inputRef}
                            required
                        />
                    </div>
                    <div>
                        <label className="float-left">
                            <b>CHY AMT</b>
                        </label>
                    </div>
                    <div className="input-group mb-2">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="0"
                            ref={this.props.outputRef}
                            disabled
                        />
                    </div>
                    <div className="padder">
                        {investButton}
                    </div>
                </form>
                <Modal show={this.state.showDialog} onHide={this.handleClose} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {this.state.tronWeb.installed ? (
                                this.state.tronWeb.loggedIn ? (
                                    <></>
                                ) : (
                                    <div>Login to TronLink Wallet</div>
                                )
                            ) : (
                                <div>Install TronLink Extension</div>
                            )}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.tronWeb.installed ? (
                            this.state.tronWeb.loggedIn ? (
                                <></>
                            ) : (
                                <div>
                                    Login to TronLink Wallet and refresh the page.
                                </div>
                            )
                        ) : (
                            <div>Download TronLink Wallet Extension from Chrome Webstore and refresh the page.</div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
                <SendingTokensModal
                    sendingTokens={this.state.sendingTokens}
                />
            </>
        );
    }
}

export default InvestForm;